const quickActionsEmailInputSelector = "#quick-actions-sign-up-email-input";
const quickActionsFormSelector = "#quick-actions-sign-up form";
const quickActionsSlidableFormSelector = quickActionsFormSelector + " .slidable";
const quickActionsFormSubmitSelector = "#quick-actions-sign-up-form-submit";
const quickActionsFormErrorsSelector = "#quick-actions-sign-up-errors";
const quickActionsSuccessSelector = "#quick-actions-sign-up-success";

let formExpanded = false;

jQuery( quickActionsEmailInputSelector ).focusin(function() {
    if(!formExpanded) {
        jQuery( quickActionsEmailInputSelector ).attr("placeholder", "Email Address");
        jQuery( quickActionsSlidableFormSelector ).slideDown(300, function() {
            formExpanded = true;
        });
    }
});

function isValidEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function submitForm(formSelector, errorsSelector, successCallback) {
    jQuery(errorsSelector).hide();
    jQuery(errorsSelector).html("");

    const emailAddress = jQuery( formSelector + " input[name=email_address]" ).val();
    if(!isValidEmail(emailAddress)) {
        jQuery(errorsSelector).html("Please enter a valid email address!");
        jQuery(errorsSelector).show();
        return;
    }

    const firstName = jQuery( formSelector + " input[name=first_name]" ).val();
    if(!firstName) {
        jQuery(errorsSelector).html("Please enter your first name.");
        jQuery(errorsSelector).show();
        return;
    }

    const lastName = jQuery( formSelector + " input[name=last_name]" ).val();
    if(!lastName) {
        jQuery(errorsSelector).html("Please enter your last name.");
        jQuery(errorsSelector).show();
        return;
    }

    const mailingAddress = jQuery( formSelector + " input[name=mailing_address]" ).val();
    if(!mailingAddress) {
        jQuery(errorsSelector).html("Please enter your mailing address.");
        jQuery(errorsSelector).show();
        return;
    }

    // submit form
    jQuery.ajax({
        type: "POST",
        crossDomain: true,
        url: "https://assets.ilhousegop.org/member-sites/ajax/nb-signup/signup.php", 
        data: {
            first_name: firstName,
            last_name: lastName,
            email: emailAddress,
            address: mailingAddress,
            rep_name: jQuery(formSelector).attr("data-rep-name")
        }
    }).done(function(response) {
        if(response.response == "fail") {
            console.log("Sign Up Error: " + response.message);
            jQuery(errorsSelector).html("An error has occured. Please try again later.");
            jQuery(errorsSelector).show();

            return;
        }

        if(successCallback) {
            successCallback();
        }

    }).fail(function(error) {
        console.log(error);
        jQuery(errorsSelector).html("An error has occured. Please try again later.");
        jQuery(errorsSelector).show();
    });
}


jQuery( quickActionsFormSubmitSelector ).click(function(e) {
    e.preventDefault();

    submitForm(quickActionsFormSelector, quickActionsFormErrorsSelector, function() {
        jQuery( quickActionsSlidableFormSelector ).slideUp(300, function() {
            formExpanded = false;
    
            jQuery( quickActionsEmailInputSelector ).fadeOut(300, function() {
                jQuery( quickActionsSuccessSelector ).fadeIn(300);
            });
        });
    });
});

jQuery( "#page-sign-up-form-submit" ).click(function(e) {
    e.preventDefault();

    submitForm("#page-sign-up form", "#page-sign-up-errors", function() {
        jQuery("#page-sign-up-success").fadeIn(300);
    });
});